var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "to-create" },
    [
      _vm.step === "step1"
        ? [
            _c(
              "el-aside",
              {
                staticClass: "aside-left",
                style: { height: _vm.boxHeight },
                attrs: { width: "2.80rem" }
              },
              [
                _c("p", { staticClass: "page-total" }, [
                  _vm._v(
                    "\n          共" +
                      _vm._s(_vm.contractInfo.items) +
                      "页\n          "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "fr color-success cred",
                      attrs: { href: "javascript: void(0)" },
                      on: {
                        click: function($event) {
                          return _vm.apiMethods.FileOperController.download_down(
                            {
                              targetId: _vm.contractInfo.contractId,
                              fileType: _vm.fileType,
                              sign: _vm.contractInfo.sign,
                              ts: _vm.contractInfo.ts,
                              fix: ".pdf"
                            }
                          )
                        }
                      }
                    },
                    [_vm._v("下载")]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "page-con" },
                  [
                    _vm._l(_vm.contractInfo.items, function(i) {
                      return [
                        _c(
                          "div",
                          {
                            key: i,
                            staticClass: "list",
                            class: _vm.currentInfo.page === i ? "active" : "",
                            on: {
                              click: function($event) {
                                return _vm.getContractDetailByNum(i)
                              }
                            }
                          },
                          [
                            _vm.contractList[i]
                              ? _c("img", {
                                  attrs: { src: _vm.contractList[i].url }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: "/images/contr_default.jpg",
                                    alt: ""
                                  }
                                }),
                            _c("span", [_vm._v(_vm._s(i))])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                ),
                _c("div", { staticClass: "go-Page" }, [
                  _c("div", [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "bd" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "输入页码", type: "number" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleContractPageClick.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.goPageNum,
                              callback: function($$v) {
                                _vm.goPageNum = $$v
                              },
                              expression: "goPageNum"
                            }
                          }),
                          _vm._v(
                            "\n                /" +
                              _vm._s(_vm.contractInfo.items) +
                              "\n              "
                          )
                        ],
                        1
                      ),
                      _c("a", { on: { click: _vm.handleContractPageClick } }, [
                        _vm._v("GO")
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _c(
              "el-main",
              { staticClass: "main-content", style: { height: _vm.boxHeight } },
              [
                _c("contract-view", {
                  ref: "contractView",
                  attrs: {
                    chapteFixed: _vm.chapteFixed,
                    "contract-info": _vm.currentInfo,
                    page: _vm.currentInfo.page,
                    items: _vm.contractInfo.items,
                    scaleValue: _vm.scaleValue,
                    "chapter-list": _vm.chapteList
                  },
                  on: {
                    "update:contractInfo": function($event) {
                      _vm.currentInfo = $event
                    },
                    "update:contract-info": function($event) {
                      _vm.currentInfo = $event
                    },
                    "update:scaleValue": function($event) {
                      _vm.scaleValue = $event
                    },
                    "update:scale-value": function($event) {
                      _vm.scaleValue = $event
                    },
                    "update:chapterList": function($event) {
                      _vm.chapteList = $event
                    },
                    "update:chapter-list": function($event) {
                      _vm.chapteList = $event
                    },
                    "pre-page": function($event) {
                      return _vm.getContractDetailByNum($event)
                    },
                    "next-page": function($event) {
                      return _vm.getContractDetailByNum($event)
                    },
                    toCurrentPage: _vm.toCurrentPage
                  }
                }),
                _c(
                  "div",
                  {
                    ref: "accessory",
                    staticClass: "text-center accessory-box"
                  },
                  [
                    _vm.contractInfo &&
                    _vm.contractInfo.items &&
                    _vm.contractInfo.items > 1
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "jumpFirst",
                              on: {
                                click: function($event) {
                                  return _vm.goPageAndFixed(1)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/btn-down.png")
                                }
                              })
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "jumpLast",
                              on: {
                                click: function($event) {
                                  return _vm.goPageAndFixed(
                                    _vm.contractInfo.items
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/btn-down.png")
                                }
                              })
                            ]
                          )
                        ]
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        ref: "step4",
                        staticClass: "text-center btn",
                        on: {
                          click: function($event) {
                            _vm.accessoryShow = !_vm.accessoryShow
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "el-icon-circle-plus" }),
                        _vm._v("\n            附属材料"),
                        _vm.accessoryShow
                          ? _c("i", { staticClass: "el-icon-arrow-down arrow" })
                          : _c("i", { staticClass: "el-icon-arrow-up arrow" })
                      ]
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "text-left accessory-list",
                        attrs: { id: "accessoryList" }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              top: "10px",
                              left: "15px",
                              color: "rgba(0,0,0,0.65)",
                              "font-size": "12px"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "8px",
                                height: "8px",
                                "margin-right": "3px",
                                "vertical-align": "middle"
                              },
                              attrs: {
                                src: require("../../assets/images/x-icon.png")
                              }
                            }),
                            _vm._v("仅供参与方查阅，不用于签署")
                          ]
                        ),
                        _c(
                          "li",
                          { staticClass: "accessory-group" },
                          [
                            _vm.attatchFileNamesJson.length
                              ? _vm._l(_vm.attatchFileNamesJson, function(
                                  item,
                                  i
                                ) {
                                  return _c(
                                    "p",
                                    { key: i, staticClass: "list-item" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            item.fileName || item.origiName
                                          )
                                        )
                                      ]),
                                      !item.isTplFile
                                        ? _c("i", {
                                            staticClass: "el-icon-error del",
                                            on: {
                                              click: function($event) {
                                                return _vm.delAttatchFileNamesJson(
                                                  item,
                                                  i
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                })
                              : _vm._e(),
                            _vm.attatchFileNamesJson.length < 3
                              ? _c(
                                  "div",
                                  { staticClass: "title upload-accessory" },
                                  [
                                    _c("div", { staticClass: "div-upload" }, [
                                      _vm._v("+")
                                    ]),
                                    _c("input", {
                                      staticClass: "input-upload",
                                      attrs: {
                                        type: "file",
                                        name: "attatchInput"
                                      },
                                      on: {
                                        change: _vm.handleAttatchFileUpload
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  2
                )
              ],
              1
            ),
            _c(
              "el-aside",
              {
                staticClass: "aside-right",
                style: { height: _vm.boxHeight },
                attrs: { width: "2.80rem" }
              },
              [
                _c("div", { staticClass: "top" }, [
                  _c("h1", { staticClass: "t-title" }, [
                    _vm._v("填写模板变量")
                  ]),
                  _c(
                    "div",
                    { staticClass: "box" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "varForm",
                          staticClass: "variablesForm",
                          attrs: {
                            "label-width": "40px",
                            model: _vm.getWidgets
                          }
                        },
                        [
                          _vm.getWidgets && _vm.getWidgets.chapteList.length
                            ? [
                                _vm._l(_vm.getWidgets.chapteList, function(
                                  item,
                                  index
                                ) {
                                  return [
                                    item.varType < _vm.flagType.flag.SIGNNATURE
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              key: index,
                                              staticClass: "var-name-sty"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.showName(item)
                                                    ? item.varName
                                                    : item.inputId
                                                )
                                              )
                                            ]
                                          ),
                                          item.varType ===
                                          _vm.flagType.flag.SYSTEMDATE
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + ""
                                                  }
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(_vm._s(item.varName))
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          item.varType ===
                                          _vm.flagType.flag.MULTITEXT
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message: "请输入文本",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      type: "textarea",
                                                      resize: "none",
                                                      rows: 4,
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType == _vm.flagType.flag.TEXT
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message: "请输入文本",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.NUMBER
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message: "请输入数字",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator.number,
                                                        message: "请输入数值",
                                                        trigger: "change",
                                                        emptyAble: true
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType == _vm.flagType.flag.DATE
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message: "请选择日期",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator.regex,
                                                        regex: /^(\d{4}-\d{2}-\d{2})?$/,
                                                        message:
                                                          "请选择正确的日期",
                                                        trigger: "change",
                                                        emptyAble: true
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      align: "left",
                                                      type: "date",
                                                      editable: false,
                                                      clearable: !item.varIsMust,
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.PHONE
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message:
                                                          "请输入手机号码",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator.mobile,
                                                        trigger: "change",
                                                        emptyAble: true
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.IDCARD
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message:
                                                          "请输入中国大陆18位身份证号码",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator.idCard,
                                                        trigger: "change",
                                                        emptyAble: true
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.LICENCENO
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message:
                                                          "请输入营业执照号",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .businessLicenseVal,
                                                        trigger: "change",
                                                        emptyAble: true
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.SOCIALCODE
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message:
                                                          "请输入统一社会信用代码",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .businessLicenseVal,
                                                        trigger: "change",
                                                        emptyAble: true
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.EMAIL
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message:
                                                          "请输入电子邮箱",
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator
                                                            .maxLength,
                                                        maxLength:
                                                          item.fontMaxNum,
                                                        trigger: "change"
                                                      },
                                                      {
                                                        validator:
                                                          _vm.$validator.email,
                                                        trigger: "change",
                                                        emptyAble: true
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    class: {
                                                      outstanding: !!item.selected
                                                    },
                                                    attrs: {
                                                      placeholder:
                                                        item.varName ||
                                                        _vm.flagType.getFlagOption(
                                                          item.varType
                                                        ).title,
                                                      maxlength: item.fontMaxNum
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.chapValChange(
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.focusWidget(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.RADIO
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message: "请选择选项",
                                                        trigger: "change"
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.chapValChange(
                                                            $event,
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: item.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.value"
                                                      }
                                                    },
                                                    _vm._l(
                                                      item.defineValue,
                                                      function(vv, i) {
                                                        return _c(
                                                          "div",
                                                          { key: i },
                                                          [
                                                            _c(
                                                              "el-radio",
                                                              {
                                                                attrs: {
                                                                  label: vv.val
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(vv.val)
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.varType ==
                                          _vm.flagType.flag.MULTIPLE
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  key: "chap-" + index,
                                                  attrs: {
                                                    label: index + 1 + "",
                                                    prop:
                                                      "chapteList." +
                                                      index +
                                                      ".value",
                                                    rules: [
                                                      {
                                                        required:
                                                          item.varIsMust,
                                                        message: "请选择选项",
                                                        trigger: "change"
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox-group",
                                                    {
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.chapValChange(
                                                            $event,
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: item.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.value"
                                                      }
                                                    },
                                                    _vm._l(
                                                      item.defineValue,
                                                      function(vv, i) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: i + new Date()
                                                          },
                                                          [
                                                            _c(
                                                              "el-checkbox",
                                                              {
                                                                attrs: {
                                                                  label: vv.val
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(vv.val)
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ]
                                })
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "bb-box" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "danger-btn",
                        attrs: { type: "danger" },
                        on: { click: _vm.nextStep }
                      },
                      [_vm._v("下一步")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        : _vm._e(),
      _vm.step === "step2"
        ? [
            _c(
              "el-form",
              {
                ref: "contForm",
                staticClass: "cont-form",
                attrs: {
                  size: "small",
                  model: _vm.contractInfo,
                  "label-width": "160px"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "f-top" },
                  [
                    _c("h4", [_c("i"), _vm._v("基础设置")]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "s-er",
                        attrs: {
                          prop: "contractName",
                          rules: _vm.myRules.tplName,
                          label: "文件名称"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: { placeholder: "请输入文件名称" },
                          model: {
                            value: _vm.contractInfo.contractName,
                            callback: function($$v) {
                              _vm.$set(_vm.contractInfo, "contractName", $$v)
                            },
                            expression: "contractInfo.contractName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { margin: "10px 0" },
                        attrs: { prop: "contractName", label: "签署链接有效期" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c("span", [_vm._v("签署链接有效期  ")]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  placement: "bottom-end"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  在指定日期之后，签署方若未完成文件签署，\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "签署方接收到的签署 “ 短信/邮件 ” 链接\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v("将失效\n        ")
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    "font-size": "16px",
                                    cursor: "pointer",
                                    color: "#a1a1a1"
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c("el-date-picker", {
                          staticClass: "datep",
                          staticStyle: { width: "260px" },
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerOptions,
                            clearable: false,
                            placeholder: "选择日期"
                          },
                          on: { change: _vm.pickTime },
                          model: {
                            value: _vm.signlinktime,
                            callback: function($$v) {
                              _vm.signlinktime = $$v
                            },
                            expression: "signlinktime"
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "card-box" }, [
                      _c(
                        "div",
                        { staticClass: "enclosure_files" },
                        [
                          _vm._v("\n              附属材料  \n              "),
                          _c(
                            "span",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    placement: "bottom-end"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "附属材料仅供参与方查阅，不用于签署"
                                      )
                                    ]
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: {
                                      display: "inline-block",
                                      "font-size": "16px",
                                      cursor: "pointer",
                                      color: "#a1a1a1"
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                margin: "0 12px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.attatchFileNamesJson.length) + "/30"
                              )
                            ]
                          ),
                          _c(
                            "el-upload",
                            {
                              attrs: {
                                action: "#",
                                multiple: "",
                                "show-file-list": false,
                                "file-list": _vm.attatchFileNamesJson,
                                "before-upload": _vm.handleAttatchFileUploadNew,
                                limit: 30,
                                "on-exceed": _vm.enclosureFilesHandleExceed,
                                "on-error": _vm.enclosureFilesError
                              }
                            },
                            [
                              _c("el-button", {
                                attrs: { icon: "el-icon-plus", size: "small" }
                              })
                            ],
                            1
                          ),
                          _vm._l(_vm.attatchFileNamesJson, function(
                            item,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "enclosureFiles-item"
                              },
                              [
                                _c("div", { staticClass: "desc" }, [
                                  _vm._v(_vm._s(item.origiName))
                                ]),
                                _c("span", {
                                  staticClass: "el-icon-error del-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.delAttatchFileNamesJson(item)
                                    }
                                  }
                                })
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ],
                  1
                ),
                _c("div", { staticClass: "f-center" }, [
                  _c("div", { staticClass: "h4" }, [
                    _c("i"),
                    _vm._v("签署设置\n            "),
                    _c("div", { staticClass: "wp" }, [
                      _c("div", { staticClass: "radio" }, [
                        _c(
                          "div",
                          {
                            staticClass: "more-set",
                            staticStyle: { "margin-left": "30px" },
                            on: {
                              click: function($event) {
                                _vm.showMoreSet = !_vm.showMoreSet
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  !_vm.showMoreSet ? "我的偏好>>" : "收起<<"
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showMoreSet,
                                expression: "showMoreSet"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  placement: "bottom-end"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      测试签约流程时，可关闭数字证书，正式签"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                      署时带数字证书可进一步保障签约有效性。\n                    "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.contractInfo.consumMode == 1,
                                      "true-label": 1,
                                      "false-label": 0
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.handleChangeCa("serverCa")
                                      }
                                    },
                                    model: {
                                      value: _vm.contractInfo.serverCa,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contractInfo,
                                          "serverCa",
                                          $$v
                                        )
                                      },
                                      expression: "contractInfo.serverCa"
                                    }
                                  },
                                  [
                                    _vm._v("\n                      数字证书"),
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      staticStyle: {
                                        "font-size": "16px",
                                        "margin-left": "10px",
                                        color: "#a1a1a1"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.contractInfo.needPresSign,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contractInfo,
                                      "needPresSign",
                                      $$v
                                    )
                                  },
                                  expression: "contractInfo.needPresSign"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    保全章\n                  "
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                on: { change: _vm.qifengChange },
                                model: {
                                  value: _vm.qiFengSign.enterpriseSign,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.qiFengSign,
                                      "enterpriseSign",
                                      $$v
                                    )
                                  },
                                  expression: "qiFengSign.enterpriseSign"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    企业骑缝章\n                  "
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                on: { change: _vm.qifengChange },
                                model: {
                                  value: _vm.qiFengSign.personSign,
                                  callback: function($$v) {
                                    _vm.$set(_vm.qiFengSign, "personSign", $$v)
                                  },
                                  expression: "qiFengSign.personSign"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    个人骑缝章\n                  "
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.personImgSign,
                                  callback: function($$v) {
                                    _vm.personImgSign = $$v
                                  },
                                  expression: "personImgSign"
                                }
                              },
                              [_vm._v("个人仅可使用图形章")]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.contractInfo.hideSignDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contractInfo,
                                      "hideSignDate",
                                      $$v
                                    )
                                  },
                                  expression: "contractInfo.hideSignDate"
                                }
                              },
                              [_vm._v("签章时间")]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.waterConfig.switch,
                                  callback: function($$v) {
                                    _vm.$set(_vm.waterConfig, "switch", $$v)
                                  },
                                  expression: "waterConfig.switch"
                                }
                              },
                              [_vm._v("文件水印 ")]
                            ),
                            _c("i", {
                              staticClass: "el-icon-setting",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.setWatermarkVisible = true
                                }
                              }
                            }),
                            !_vm.isInDingTalk
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "prtf-sty",
                                    staticStyle: {
                                      display: "inline-block",
                                      "line-height": "20px",
                                      border: "1px solid #888888",
                                      "border-radius": "4px",
                                      padding: "4px 10px"
                                    },
                                    on: { click: _vm.turnPref }
                                  },
                                  [_vm._v("偏好设置")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "tab" }, [
                    _vm.signatoryJson && _vm.signatoryJson.length
                      ? _c(
                          "div",
                          { staticClass: "list-box" },
                          [
                            _vm._l(_vm.signatoryJson, function(item, i) {
                              return [
                                _c(
                                  "el-form",
                                  {
                                    key: i,
                                    ref: "contractListTab",
                                    refInFor: true,
                                    staticClass: "contract-lit__tab",
                                    attrs: {
                                      model: item,
                                      size: "small",
                                      "data-signOwner": item.signOwner
                                    }
                                  },
                                  [
                                    item.fix == 1
                                      ? _c("div", { staticClass: "t-row" }, [
                                          _vm.contractInfo.ifOrder
                                            ? _c(
                                                "span",
                                                { staticClass: "index" },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(i + 1) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ov",
                                              staticStyle: {
                                                width: "106px",
                                                "margin-left": "15px"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.signOwner))]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ov",
                                              staticStyle: { width: "80px" }
                                            },
                                            [_vm._v("固定人员：")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ov",
                                              staticStyle: {
                                                width: "220px",
                                                "margin-right": "25px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(item.emailOrPhone) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ov",
                                              staticStyle: {
                                                width: "240px",
                                                "margin-right": "25px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    item.signatoryFullName
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ov",
                                              staticStyle: {
                                                width: "70px",
                                                "margin-right": "25px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    +item.signatoryUserType ===
                                                      0
                                                      ? "个人"
                                                      : +item.signatoryUserType ===
                                                        1
                                                      ? "企业"
                                                      : "港澳台个人"
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ov",
                                              staticStyle: {
                                                width: "185px",
                                                "margin-right": "20px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    item.signatoryIdentityCard
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ov fb" },
                                            [
                                              +item.authLevel === 11
                                                ? _c("i", {
                                                    staticClass: "icon-gg"
                                                  })
                                                : _c("i", {
                                                    staticClass: "icon-nogg"
                                                  }),
                                              _vm._v(
                                                "\n                        需要人脸识别\n                        "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "light",
                                                    content: "",
                                                    placement: "bottom-end"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content"
                                                      },
                                                      slot: "content"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            选择人脸识别，可把签署方的\n                            "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "人脸视频文件作为签署证据\n                          "
                                                      )
                                                    ]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question",
                                                    staticStyle: {
                                                      "font-size": "16px",
                                                      "margin-left": "10px",
                                                      color: "#a1a1a1",
                                                      cursor: "pointer"
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      : _c("div", { staticClass: "t-row" }, [
                                          _vm.contractInfo.ifOrder
                                            ? _c(
                                                "span",
                                                { staticClass: "index" },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(i + 1) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "user-type",
                                              staticStyle: {
                                                width: "106px",
                                                "margin-left": "15px"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.signOwner))]
                                          ),
                                          _c(
                                            "div",
                                            { staticStyle: { width: "80px" } },
                                            [_vm._v("指定人员：")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col",
                                              staticStyle: {
                                                width: "220px",
                                                "margin-right": "25px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "emailOrPhone",
                                                    rules:
                                                      _vm.rulesTab.emailOrPhone
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "签署方接收手机/邮箱"
                                                      },
                                                      on: {
                                                        blur: function() {
                                                          ;(item.emailOrPhone = _vm.$utils.trim(
                                                            item.emailOrPhone
                                                          )),
                                                            _vm.getUserInfoBySelectTargetId(
                                                              item.emailOrPhone,
                                                              i
                                                            )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.emailOrPhone,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "emailOrPhone",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.emailOrPhone"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "icon icon-btn_tels",
                                                        staticStyle: {
                                                          "background-size":
                                                            "contain",
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          slot: "suffix"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleTelsClickOther(
                                                              item,
                                                              i
                                                            )
                                                          }
                                                        },
                                                        slot: "suffix"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col",
                                              staticStyle: {
                                                width: "240px",
                                                "margin-right": "25px"
                                              }
                                            },
                                            [
                                              item.canSelectArray &&
                                              ((+item.signatoryUserType === 1 &&
                                                item.canSelectArray.length >
                                                  0 &&
                                                !item.ManualInput) ||
                                                (+item.signatoryUserType ===
                                                  0 &&
                                                  item.canSelectArray.length >
                                                    1))
                                                ? [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "select",
                                                            staticStyle: {
                                                              width: "100%"
                                                            },
                                                            attrs: {
                                                              size: "small"
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.handleSelectCorpAccount(
                                                                  $event,
                                                                  item
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                item.canSelectArrayIndex,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "canSelectArrayIndex",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.canSelectArrayIndex"
                                                            }
                                                          },
                                                          [
                                                            _vm._l(
                                                              item.canSelectArray,
                                                              function(v, vi) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: vi,
                                                                    attrs: {
                                                                      value: vi,
                                                                      label:
                                                                        v.name
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            item.signatoryUserType ===
                                                            1
                                                              ? _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        "ManualInput",
                                                                      label:
                                                                        "手动输入"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          prop:
                                                            "signatoryFullName",
                                                          rules:
                                                            _vm.rulesTab
                                                              .signatoryFullName,
                                                          "show-message":
                                                            item.disabled !==
                                                            "disabled"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            value:
                                                              item.signatoryFullName,
                                                            disabled:
                                                              item.disabled ===
                                                              "disabled",
                                                            placeholder:
                                                              "请输入签署方名称"
                                                          },
                                                          on: {
                                                            input: function(
                                                              val
                                                            ) {
                                                              item.signatoryFullName = val
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col",
                                              staticStyle: {
                                                width: "70px",
                                                "margin-right": "25px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticClass: "select",
                                                      attrs: {
                                                        disabled:
                                                          item.disabled ===
                                                          "disabled",
                                                        size: "small"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleSignUserType(
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.signatoryUserType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "signatoryUserType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.signatoryUserType"
                                                      }
                                                    },
                                                    [
                                                      _c("el-option", {
                                                        attrs: {
                                                          value: 0,
                                                          label: "个人"
                                                        }
                                                      }),
                                                      _c("el-option", {
                                                        attrs: {
                                                          value: 1,
                                                          label: "企业"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          item.signatoryUserType === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "col",
                                                  staticStyle: {
                                                    width: "185px",
                                                    "margin-right": "20px"
                                                  }
                                                },
                                                [
                                                  item.signatoryUserType ===
                                                    0 &&
                                                  !_vm.contractInfo.serverCa
                                                    ? _c(
                                                        "el-form-item",
                                                        {
                                                          staticStyle: {
                                                            position: "relative"
                                                          },
                                                          attrs: {
                                                            prop: "IDCard",
                                                            rules:
                                                              item.disabled !==
                                                              "disabled"
                                                                ? _vm.rulesTab
                                                                    .IDCard
                                                                : {},
                                                            "show-message":
                                                              item.disabled !==
                                                              "disabled"
                                                          }
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            class: {
                                                              "no-padding": item.disabled
                                                                ? true
                                                                : false
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                item.disabled ===
                                                                "disabled",
                                                              placeholder:
                                                                "请输入中国大陆18位身份证号码"
                                                            },
                                                            model: {
                                                              value:
                                                                item.IDCard,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "IDCard",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.IDCard"
                                                            }
                                                          }),
                                                          item.ischange === 1
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "color-success amend-signator amend-tab__form",
                                                                  attrs: {
                                                                    href:
                                                                      "javascript:void (0)"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleTargetIdChange(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("修改")]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "fb" },
                                            [
                                              +item.authLevel === 11
                                                ? _c("i", {
                                                    staticClass: "icon-gg"
                                                  })
                                                : _c("i", {
                                                    staticClass: "icon-nogg"
                                                  }),
                                              _vm._v(
                                                "\n                        需要人脸识别\n                        "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "light",
                                                    content: "",
                                                    placement: "bottom-end"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content"
                                                      },
                                                      slot: "content"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            选择人脸识别，可把签署方的\n                            "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "人脸视频文件作为签署证据\n                          "
                                                      )
                                                    ]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question",
                                                    staticStyle: {
                                                      "font-size": "16px",
                                                      "margin-left": "10px",
                                                      color: "#a1a1a1",
                                                      cursor: "pointer"
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]),
                _vm.isGroup &&
                _vm.checkedBatch === false &&
                _vm.hasApplyApproval === true
                  ? _c(
                      "div",
                      { staticClass: "f-center2" },
                      [
                        _c("el-form-item", [
                          _c(
                            "h4",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "margin-right": "15px"
                              }
                            },
                            [_c("i"), _vm._v("选择审批流程\n            ")]
                          ),
                          _c(
                            "div",
                            { staticClass: "bow" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    placeholder: "请选择审批流程"
                                  },
                                  on: { change: _vm.handleChangeApprovalFlow },
                                  model: {
                                    value: _vm.approvalFlowSelect,
                                    callback: function($$v) {
                                      _vm.approvalFlowSelect = $$v
                                    },
                                    expression: "approvalFlowSelect"
                                  }
                                },
                                _vm._l(_vm.approvalFlowList, function(
                                  v,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      value: v.flowId,
                                      label: v.flowName
                                    }
                                  })
                                }),
                                1
                              ),
                              _vm.flows.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        border: "1px solid rgba(229,229,229,1)",
                                        "border-radius": "4px",
                                        "margin-top": "12px"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            position: "relative"
                                          }
                                        },
                                        _vm._l(_vm.flows, function(v, index) {
                                          return _c(
                                            "flow",
                                            {
                                              key: index,
                                              attrs: {
                                                model: v,
                                                hiddenArrow: v.hiddenArrow,
                                                hiddenRemove: false
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "username" },
                                                  slot: "username"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#aaaaaa"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(v.partyName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isGroup && _vm.checkedBatch === false
                  ? _c(
                      "div",
                      { staticClass: "f-center2" },
                      [
                        _c("el-form-item", [
                          _c("h4", [
                            _c("i"),
                            _vm._v("设置抄送人\n            ")
                          ])
                        ]),
                        _c("el-form-item", { staticClass: "bow" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                border: "1px solid rgba(229,229,229,1)",
                                "border-radius": "4px",
                                overflow: "hidden",
                                padding: "8px 0"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "audit-flex" },
                                [
                                  _vm._l(_vm.arrayCopior, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "audit-box" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon icon-audit-touxiang66"
                                        }),
                                        _c("div", { staticClass: "auditor" }, [
                                          _vm._v(
                                            _vm._s(
                                              item.userName || item.partyName
                                            )
                                          )
                                        ]),
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !item.hideRemove,
                                              expression: "!item.hideRemove"
                                            }
                                          ],
                                          staticClass:
                                            "icon icon-audit-cuowu17 size17",
                                          on: {
                                            click: function($event) {
                                              return _vm.handleClickRemoveArrayCopior(
                                                index
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "audit-add",
                                      on: {
                                        click: function($event) {
                                          return _vm.clickHandleAddAuditorOrCopyer(
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon icon-audit-add-2x",
                                        staticStyle: {
                                          width: "78px",
                                          height: "78px"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isMine()
                  ? _c(
                      "div",
                      { staticClass: "f-center2" },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("p", { staticClass: "cc_title" }, [
                              _vm._v("选择签章")
                            ]),
                            [
                              _vm.chapterList.length
                                ? _c(
                                    "div",
                                    { staticClass: "temone-box" },
                                    [
                                      _vm._l(_vm.chapterList, function(
                                        item,
                                        index
                                      ) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "temone-chap",
                                              class: {
                                                "select-border": _vm.chapterCheck.includes(
                                                  item.corpSealId
                                                )
                                                  ? true
                                                  : false
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectChap(item)
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "select_img",
                                                attrs: {
                                                  src: "/images/selected.png",
                                                  alt: ""
                                                }
                                              }),
                                              _c(
                                                "div",
                                                { staticClass: "info_box" },
                                                [
                                                  _c(
                                                    "el-popover",
                                                    {
                                                      attrs: {
                                                        placement: "top-start",
                                                        trigger: "hover"
                                                      }
                                                    },
                                                    [
                                                      (!_vm.isInDingTalk &&
                                                        item.flowDetail) ||
                                                      (_vm.isInDingTalk &&
                                                        item.dingTalkFlow)
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                padding: "10px",
                                                                "font-weight":
                                                                  "bold"
                                                              }
                                                            },
                                                            [
                                                              _c("p", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      !_vm.isInDingTalk
                                                                        ? item.flowDetail &&
                                                                            item
                                                                              .flowDetail
                                                                              .flowName
                                                                        : _vm.isInDingTalk &&
                                                                          item.dingTalkFlow
                                                                        ? item
                                                                            .dingTalkFlow
                                                                            .flowName
                                                                        : ""
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    height:
                                                                      "125px",
                                                                    overflow:
                                                                      "auto"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "approval-process",
                                                                    {
                                                                      attrs: {
                                                                        flowInfo: _vm.computeInfo(
                                                                          _vm.isInDingTalk
                                                                            ? item.dingTalkFlow
                                                                            : item.flowDetail
                                                                        ),
                                                                        orderFlag: _vm.isInDingTalk
                                                                          ? item
                                                                              .dingTalkFlow
                                                                              .flowType
                                                                          : item
                                                                              .flowDetail
                                                                              .orderFlag
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        : _c("div", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticStyle: {
                                                                  padding:
                                                                    "20px",
                                                                  color:
                                                                    "#606266",
                                                                  "font-weight":
                                                                    "bold"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "无审批流程"
                                                                )
                                                              ]
                                                            )
                                                          ]),
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            slot: "reference"
                                                          },
                                                          slot: "reference"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "t-box"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "y-img",
                                                                attrs: {
                                                                  src:
                                                                    item.signUrl,
                                                                  title:
                                                                    item.sealName
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              attrs: {
                                                                title:
                                                                  "" +
                                                                  item.sealName
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  "" +
                                                                    item.sealName
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                : _c(
                                    "p",
                                    { staticStyle: { color: "#ec1c1e" } },
                                    [
                                      _vm._v(
                                        "\n                您还没有获得企业印章的使用授权，可继续发起合同，请在签署前联系管理员给您进行印章授权！\n              "
                                      )
                                    ]
                                  )
                            ]
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "f-btn nobg-btn",
                        on: { click: _vm.preStep }
                      },
                      [_vm._v("上一步")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "f-btn",
                        attrs: { type: "danger" },
                        on: { click: _vm.publishTpl }
                      },
                      [_vm._v("立即发起")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.auditAndCopyTitle,
            visible: _vm.visibleAuditAndCopy,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleAuditAndCopy = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { staticClass: "tel-search" },
            [
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-col",
                    { staticStyle: { padding: "0 10px" }, attrs: { span: 8 } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          size: "small",
                          placeholder: "邮箱/手机号"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.clickHandleAuditorOrCopyerSearch()
                          }
                        },
                        model: {
                          value: _vm.auditAndCopyModel.keyword,
                          callback: function($$v) {
                            _vm.$set(_vm.auditAndCopyModel, "keyword", $$v)
                          },
                          expression: "auditAndCopyModel.keyword"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { padding: "0 10px" }, attrs: { span: 8 } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          size: "small",
                          placeholder: "签署方名称"
                        },
                        model: {
                          value: _vm.auditAndCopyModel.corpUserName,
                          callback: function($$v) {
                            _vm.$set(_vm.auditAndCopyModel, "corpUserName", $$v)
                          },
                          expression: "auditAndCopyModel.corpUserName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { padding: "0 10px" }, attrs: { span: 8 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择部门", size: "small" },
                          model: {
                            value: _vm.auditAndCopyModel.corpGroupId,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.auditAndCopyModel,
                                "corpGroupId",
                                $$v
                              )
                            },
                            expression: "auditAndCopyModel.corpGroupId"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" }
                          }),
                          _vm._l(_vm.department, function(item, i) {
                            return _c("el-option", {
                              key: i,
                              attrs: {
                                label: item.groupName,
                                value: item.corpGroupId
                              }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5, offset: 1 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.clickHandleAuditorOrCopyerSearch()
                        }
                      }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "tel-box",
              staticStyle: { height: "415px", overflow: "auto" }
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.auditAndCopyModel.loading,
                      expression: "auditAndCopyModel.loading"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    "empty-text": _vm.auditAndCopyModel.emptyText,
                    data: _vm.tableListAuditAndCopy,
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                    stripe: "",
                    "cell-style": { cursor: "pointer" },
                    "header-cell-style": {
                      background: "#f9f9f9",
                      color: "#333333",
                      fontWeight: "500"
                    }
                  },
                  on: { "row-click": _vm.handleRowClickAuditAndCopy }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "签署方名称", prop: "userName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "邮箱/手机号", prop: "targetId" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "部门", prop: "groupNames" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("br"),
          _c("el-pagination", {
            staticStyle: { "text-align": "right" },
            attrs: {
              "current-page": _vm.auditAndCopyModel.itemPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.auditAndCopyModel.pageSize,
              layout: "sizes, prev, pager, next, jumper, total",
              total: _vm.auditAndCopyModel.total
            },
            on: {
              "size-change": _vm.handleSizeChangeQueryToolAuditAndCopy,
              "current-change": _vm.handleCurrentChangeQueryToolAuditAndCopy
            }
          }),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.visibleAuditAndCopy = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.clickHandleAddAuditorOrCopyerSubmit()
                    }
                  }
                },
                [_vm._v("添加")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sign-info-tips-dialog", {
        attrs: {
          show: _vm.visibleCredit,
          entCreditArr: _vm.entCreditArr,
          entCreditJson: _vm.entCreditJson,
          userIdentityInfoArr: _vm.userIdentityInfoArr
        },
        on: {
          "update:show": function($event) {
            _vm.visibleCredit = $event
          },
          continue: _vm.addContractById,
          cancel: _vm.handleDelSendContract
        }
      }),
      _c(
        "el-dialog",
        {
          staticClass: "prise-dialog",
          attrs: {
            visible: _vm.priseVisibleDialog,
            title: "温馨提示",
            "show-close": false,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.priseVisibleDialog = $event
            },
            closed: _vm.handleDelSendContract
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "box-dashed text-center",
              staticStyle: { "margin-top": "10px", "padding-bottom": "5px" }
            },
            [
              _c("img", {
                staticStyle: { height: "80px" },
                attrs: { src: "/images/icon_signed.png" }
              }),
              _vm.priseInfo.mealInfo
                ? [
                    _c("h4", [
                      _vm._v("\n            本次共花费：\n            "),
                      _c("span", { staticClass: "color-danger" }, [
                        _vm._v(_vm._s(_vm.priseInfo.mealInfo))
                      ])
                    ]),
                    _vm.priseInfo.point
                      ? _c("h4", [
                          _vm._v("\n            另需要支付\n            "),
                          _c("span", { staticClass: "color-danger" }, [
                            _vm._v(_vm._s(_vm.priseInfo.point) + "积分")
                          ])
                        ])
                      : _vm._e()
                  ]
                : _c("h4", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("\n          本次共花费：\n          "),
                    _c("span", { staticClass: "color-danger" }, [
                      _vm._v(_vm._s(_vm.priseInfo.point) + "积分")
                    ])
                  ]),
              _c(
                "p",
                {
                  staticStyle: { "text-align": "start", "margin-left": "8px" }
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    "\n          发起后，签署方将收到签署短信通知，该通知72小时有效，请尽快完成签署！\n        "
                  )
                ]
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "footer-btn",
                  attrs: {
                    type: "danger",
                    size: "small",
                    disabled: _vm.payDisabled
                  },
                  on: {
                    click: function($event) {
                      return _vm.toPay(_vm.priseInfo.cashierUrl)
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择签署方",
            visible: _vm.showTel,
            "lock-scroll": "",
            width: "749px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showTel = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTabSigner,
                callback: function($$v) {
                  _vm.activeTabSigner = $$v
                },
                expression: "activeTabSigner"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "常用签署方", name: "default" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "tel-search" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "邮箱/手机号"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.getTelList()
                              }
                            },
                            model: {
                              value: _vm.telPageInfo.accountNo,
                              callback: function($$v) {
                                _vm.$set(_vm.telPageInfo, "accountNo", $$v)
                              },
                              expression: "telPageInfo.accountNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6, offset: 1 } },
                        [
                          _c("el-input", {
                            attrs: { size: "small", placeholder: "签署方姓名" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.getTelList()
                              }
                            },
                            model: {
                              value: _vm.telPageInfo.name,
                              callback: function($$v) {
                                _vm.$set(_vm.telPageInfo, "name", $$v)
                              },
                              expression: "telPageInfo.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6, offset: 1 } },
                        [
                          _c("el-input", {
                            attrs: { size: "small", placeholder: "证件号" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.getTelList()
                              }
                            },
                            model: {
                              value: _vm.telPageInfo.idNo,
                              callback: function($$v) {
                                _vm.$set(_vm.telPageInfo, "idNo", $$v)
                              },
                              expression: "telPageInfo.idNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 3, offset: 1 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "small" },
                              on: { click: _vm.getTelList }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "tel-box",
                      staticStyle: {
                        "max-height": "340px",
                        overflow: "auto",
                        "min-width": "749px"
                      }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.telList,
                            "highlight-current-row": "",
                            "tooltip-effect": "dark",
                            stripe: "",
                            "cell-style": { cursor: "pointer" },
                            "header-cell-style": {
                              background: "#f9f9f9",
                              color: "#333333",
                              fontWeight: "500"
                            }
                          },
                          on: { "row-click": _vm.handleTelRowClickSelectRow }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "签署方名称",
                              prop: "enterpriseName"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { label: "证件号", prop: "businessLicense" }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "邮箱/手机号",
                              prop: "mobileOrChild"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "text-align": "right",
                      "margin-top": "10px"
                    },
                    attrs: {
                      "current-page": _vm.telPageInfo.itemPage,
                      "page-sizes": [6, 12, 30, 60],
                      "page-size": _vm.telPageInfo.pageSize,
                      layout: "sizes, prev, pager, next, jumper, total",
                      total: _vm.telPageInfo.total
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              ),
              _vm.isGroup
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.activeTabOrganizationName,
                        name: "organization"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { staticClass: "tel-search" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { padding: "0 10px" },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      size: "small",
                                      placeholder: "邮箱/手机号"
                                    },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.clickHandleMyCorpSearch()
                                      }
                                    },
                                    model: {
                                      value: _vm.myCorpModel.keyword,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.myCorpModel,
                                          "keyword",
                                          $$v
                                        )
                                      },
                                      expression: "myCorpModel.keyword"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { padding: "0 10px" },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      size: "small",
                                      placeholder: "签署方名称"
                                    },
                                    model: {
                                      value: _vm.myCorpModel.corpUserName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.myCorpModel,
                                          "corpUserName",
                                          $$v
                                        )
                                      },
                                      expression: "myCorpModel.corpUserName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { padding: "0 10px" },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择部门",
                                        size: "small"
                                      },
                                      model: {
                                        value: _vm.myCorpModel.corpGroupId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.myCorpModel,
                                            "corpGroupId",
                                            $$v
                                          )
                                        },
                                        expression: "myCorpModel.corpGroupId"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "全部", value: "" }
                                      }),
                                      _vm._l(_vm.department, function(item, i) {
                                        return _c("el-option", {
                                          key: i,
                                          attrs: {
                                            label: item.groupName,
                                            value: item.corpGroupId
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 5, offset: 1 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickHandleMyCorpSearch()
                                    }
                                  }
                                },
                                [_vm._v("查询")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "tel-box",
                          staticStyle: { height: "415px", overflow: "auto" }
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.myCorpModel.loading,
                                  expression: "myCorpModel.loading"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                "empty-text": _vm.myCorpModel.emptyText,
                                data: _vm.tableListMyCorp,
                                "highlight-current-row": "",
                                "tooltip-effect": "dark",
                                stripe: "",
                                "cell-style": { cursor: "pointer" },
                                "header-cell-style": {
                                  background: "#f9f9f9",
                                  color: "#333333",
                                  fontWeight: "500"
                                }
                              },
                              on: { "row-click": _vm.handleRowClickMyCorp }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "邮箱/手机号",
                                  prop: "targetId"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "签署方名称", prop: "userName" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "部门", prop: "groupNames" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c("el-pagination", {
                        staticStyle: { "text-align": "right" },
                        attrs: {
                          "current-page": _vm.myCorpModel.itemPage,
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.myCorpModel.pageSize,
                          layout: "sizes, prev, pager, next, jumper, total",
                          total: _vm.myCorpModel.total
                        },
                        on: {
                          "size-change": _vm.handleSizeChangeQueryToolMyCorp,
                          "current-change":
                            _vm.handleCurrentChangeQueryToolMyCorp
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.handleClickSelectSignorOk()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加水印",
            width: "60%",
            visible: _vm.setWatermarkVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.setWatermarkVisible = $event
            }
          }
        },
        [
          _vm.setWatermarkVisible
            ? _c("waterMark", {
                attrs: {
                  visible: _vm.setWatermarkVisible,
                  waterConfig: _vm.waterConfig
                },
                on: {
                  "update:visible": function($event) {
                    _vm.setWatermarkVisible = $event
                  },
                  "update:waterConfig": function($event) {
                    _vm.waterConfig = $event
                  },
                  "update:water-config": function($event) {
                    _vm.waterConfig = $event
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-138dd76a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-138dd76a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/advancedVersion/writeVariables.vue
// module id = 7A6X
// module chunks = 16